export default "__VITE_ASSET__U0WVAS23__"